import React, { FC } from "react";
import EChartsReact from "echarts-for-react";
import { dataEntry, IDataTest } from "../../types/types";

import {
    Paper
} from "@material-ui/core";
import { trafficLight } from "../../theme";


interface IFMChartProps {
    data: IDataTest<dataEntry>
}


const BarChart: FC<IFMChartProps> = ({ data }) => {

    let left = 320
    if (data.title === 'State of Knowledge') {
        left = 200;
    }

    const height = data.height ? data.height : "250px";


    const data_series = data.data.map((entry, index) => {

        return {

            name: entry.name,
            type: 'bar',
            color: data.colour.background[index],
            stack: 'total',
            label: {
                color: data.colour.font[index],
                fontWeight: 'bold',

            },
            emphasis: {
                focus: 'none'
            },
            data: entry.value

        }


    })


    const getOption = () => {

        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'none' // 'shadow' as default; can also be 'line' or 'shadow'
                },
                backgroundColor: 'rgba(255,255,255,0.7)',
            },
            title: {
                text: data.title,
                left: 'center',
                textStyle: {
                    color: 'black'
                }

            },
            toolbox: {
                show: true,
                top: 0,
                feature: {
                    saveAsImage: {
                        show: true,
                        pixelRatio: 4
                    },
                    dataView: {
                        show: true,
                        readOnly: false

                    }
                },

            },
            legend: {
                bottom: 'bottom'
            },
            label: {
                show: true,
                formatter: function (param: any) {
                    return param.data == 0 ? '' : param.data;
                }
            },

            grid: {
                left: left,
                right: '20',
                bottom: '60',
                top: '40',
                containLabel: false
            },
            xAxis: {
                type: 'value',
                name: 'Number of dams',
                nameGap: 25,
                nameLocation: 'middle',
            },
            yAxis: {
                type: 'category',
                data: data.description
            },
            series: data_series
        };
    }

    return (<>
        <div style={{ padding: "10px" }}>
            <Paper variant={"outlined"}>
                <EChartsReact option={getOption()} style={{ height: height }} />
            </Paper>
        </div>

    </>
    );
}

export default BarChart;
